<template>
    <div class="font-body">
        <LandingNav
            background-color="#FFFFFF"
            logo-light="/hkcm/images/logo-on-light-background.svg"
            logo-small-light="/hkcm/images/logo-small-on-light-background.svg"
            :cta-text="'Analyse-Pakete entdecken'"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
            :show-ticker="true"
            ticker-text="+++ Ø<span class='font-semibold'> 70 % Trefferquote</span> über alle Analysebereiche +++ <span class='font-semibold'>Klare</span> Einstiegs-, Ausstiegs- und Risikomarken +++ <span class='font-semibold'>Strukturierte Szenarien</span> statt Bauchgefühl +++"
        />

        <!-- 2) HERO -->
        <HeroSection
            background-color="linear-gradient(to bottom right, #072551,#020E20)"
            :badges="heroBadges"
            title="Aktienanalysen der HKCM für bessere Handels<span class='xs:hidden'>-</span>entscheidungen"
            title-highlight="Aktienanalysen"
            title-highlight-gradient-from="#11D2D4"
            title-highlight-gradient-to="#0C7475"
            subtitle="Professionelle technische Marktanalysen mit klaren Einstiegs- und Ausstiegsmarken."
            :benefits="heroBenefits"
            checkmark-color="text-blue"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            price-color="text-blue"
            :social-proof-text="'<div>Bereits über 25.000</div><div>zufriedene Kunden</div>'"
            social-proof-image="/hkcm/images/rezensionenBilder.png"
            :app-store-data="appStoreData"
            :google-play-data="googlePlayData"
            background-image="/hkcm/images/bg_candels.png"
            button-gradient-from="#11D2D4"
            button-gradient-to="#0C7475"
            fallback-cta-text="Hype-Aktien-Paket kaufen ab dem 23.02.2026"
            fallback-cta-background-color="#1E40AF"
        />

        <!-- 3) HERO-VIDEO/IMAGE -->
        <VideoSection
            background-color="transparent"
            video-url="https://iframe.mediadelivery.net/embed/369702/cd004d0c-3c1d-4796-a8bf-08670bee5205?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            discount-text="Rabatt"
            discount-percentage="20%"
            discount-badge-color="#1E40AF"
            :video-height="500"
        />

        <!-- 4) SECTION -->
        <ContentSection
            background-color="#FFFFFF"
            title="Bessere Anlageentscheidungen<br class='hidden lg:block'> im Aktienhandel"
            title-highlight="Aktienhandel"
            title-highlight-gradient-from="#11D2D4"
            title-highlight-gradient-to="#0C7475"
            title-color="text-blue-dark"
            :paragraphs="section4Paragraphs"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#11D2D4"
            button-gradient-to="#0C7475"
            fallback-cta-text="Hype-Aktien-Paket kaufen ab dem 23.02.2026"
            fallback-cta-background-color="#1E40AF"
            :tiles="section4Tiles"
            :tiles-background="'bg-[#e5f0ff]'"
            :tiles-title-color="'text-[#006CFF]'"
            :tiles-description-color="'text-black'"
        />

        <!-- 6) SECTION – 6 Karten -->
        <FeatureCardsSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Das erhalten Sie in<br>unseren Aktienpaketen"
            title-highlight="Aktienpaketen"
            title-highlight-gradient-from="#11D2D4"
            title-highlight-gradient-to="#0C7475"
            title-color="text-white"
            :cards="featureCards"
            card-background-color="bg-white"
            card-title-color="text-blue-dark"
            card-text-color="text-black"
            card-icon-color="text-blue"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#11D2D4"
            button-gradient-to="#0C7475"
            fallback-cta-text="Hype-Aktien-Paket kaufen ab dem 23.02.2026"
            fallback-cta-background-color="#1E40AF"
        />

        <!-- 13) ANALYSE-PAKETE SECTION -->
        <AnalysePaketeSection
            background-color="linear-gradient(135deg, #10D0D1 0%, #10686C 100%)"
            title="Was Sie in unseren<br class='lg:block hidden'> Analyse-Paketen erhalten?"
            title-highlight="Analyse-Paketen"
            subtitle="Wählen Sie das Analysepaket passend zu Ihrem Marktinteresse und Ihrer Strategie."
            subtitle-color="text-black"
            :packages="analysePakete"
            button-gradient-from="#0d9488"
            button-gradient-to="#06b6d4"
            icon-color="text-black"
            icon-image="https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/aktien-white.png"
        />

        <!-- 17) METHODOLOGY SECTION -->
        <MethodologySection
            background-color="bg-white"
            title="Methodische Marktanalyse statt Meinungsprognose"
            title-highlight="Marktanalyse"
            title-highlight-color="#0d9488"
            title-color="#1a1a1a"
            subtitle="Warum unsere Aktienanalysen auf der Elliott-Wellen-Theorie basieren — und was das für Ihre Entscheidungen bedeutet."
            :accordion-items="methodologyAccordionItems"
            accordion-border-color="#e5e7eb"
            accordion-text-color="#1a1a1a"
            accordion-body-color="#000"
            active-accordion-color="#006CFF"
            :image="$asset('/hkcm/images/methodology.png', 'public')"
            image-alt="Laptop mit Chartanalyse"
        />

        <!-- 12) SECTION -->
        <VideoContentSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Nachvollziehbare<br class='hidden lg:block'> Ableitung statt Blackbox"
            title-highlight="Ableitung"
            title-highlight-gradient-from="#11D2D4"
            title-highlight-gradient-to="#0C7475"
            title-color="text-white"
            content="Jede Analyse folgt einer festen methodischen Ableitung:<br>
Marktstruktur → Wellenzählung → Szenario → Marken → Update<br><br>
Das heißt:<br> Die Analyse ist nicht „gefühlt“, sondern hergeleitet.<br>
Viele Nutzer schätzen genau das — weil Entscheidungen nachvollziehbar werden und nicht auf Meinungen beruhen."
            text-color="text-white"
            video-url="https://iframe.mediadelivery.net/embed/369702/66d6620a-7dfb-4b2f-9b76-291725b802dd?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :height="384"
            position="left"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#11D2D4"
            button-gradient-to="#0C7475"
        />

        <!-- 15) WHO IS IT FOR SECTION -->
        <WhoIsItForSection
            title="Für wen unsere Analysen geeignet sind"
            title-highlight="Analysen"
            title-highlight-color="#0d9488"
            title-color="#1a1a1a"
            intro-text="Unsere Aktienanalyse-Pakete richten sich an Anleger, die ihre Investmententscheidungen eigenständig treffen — dabei aber nicht auf Bauchgefühl oder Schlagzeilen vertrauen möchten.<br> Die Analysen liefern Ihnen strukturierte Marktmodelle, Szenarien und Kursmarken.<br> Sie sind als Entscheidungsgrundlage gedacht – nicht als automatisches Handelssystem.<br> Damit Sie schnell erkennen können, ob unser Ansatz zu Ihnen passt, finden Sie hier eine klare Einordnung."
            intro-text-color="#000"
            subtitle="Besonders geeignet sind die Analysen für Sie, wenn ..."
            subtitle-highlight="Analysen"
            :cards="whoIsItForCards"
            card-border-color="#f3f4f6"
            card-title-color="#1a1a1a"
            card-text-color="#000"
            icon-color="text-blue"
            card-background="bg-[#e5f0ff]"
        />

        <!-- 16) WHAT YOU GET SECTION -->
        <WhatYouGetSection
            title="Was Sie bei HKCM<br class='hidden lg:block'> konkret erhalten —<br class='hidden lg:block'> und was nicht"
            title-highlight="HKCM"
            title-highlight-color="#2dd4bf"
            title-color="#ffffff"
            description="Damit keine falschen Erwartungen entstehen, ist uns Transparenz wichtig: <br>HKCM ist kein Broker, keine Handelsplattform und keine Vermögensverwaltung.<br class='hidden lg:block'> Sie kaufen bei uns keine Aktien und führen über uns keine Transaktionen aus.<br class='hidden lg:block'> Stattdessen erhalten Sie strukturierte, methodisch abgeleitete Marktanalysen auf Basis der Elliott-Wellen-Theorie — als fundierte Entscheidungsgrundlage für Ihre eigenen Investmententscheidungen."
            description-color="#ffffff"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            cta-style="px-4 py-4 mt-6 rounded-full font-bold text-md flex items-center gap-2 transition text-white hover:opacity-90 w-full justify-center lg:w-fit bg-gradient-to-r from-[#11D2D4] to-[#0C7475]"
            :image="$asset('/hkcm/images/ph_aktien_lp.png', 'public')"
            image-alt="HKCM Experte"
            :show-cta="true"
        />

        <!-- 12) SECTION -->
        <VideoContentSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            title="Wichtig zu verstehen"
            title-highlight="verstehen"
            title-highlight-gradient-from="#11D2D4"
            title-highlight-gradient-to="#0C7475"
            title-color="text-white"
            content="Unsere Analysen sind ein Werkzeug für strukturierte Entscheidungen — kein Ersatz für eigene Verantwortung.
Je aktiver und strukturierter Sie investieren, desto größer ist der praktische Nutzen der Analysen."
            text-color="text-white"
            video-url="https://iframe.mediadelivery.net/embed/369702/52460f00-b41a-4a1a-92d7-99d3279ec071?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :height="384"
            position="left"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#11D2D4"
            button-gradient-to="#0C7475"
        />

        <!-- 14) HOW TO USE SECTION -->
        <HowToUseSection
            background-color="#ffffff"
            title="So nutzen Sie die Aktienanalysen"
            title-highlight="Aktienanalysen"
            title-highlight-color="#0d9488"
            title-color="#1a1a1a"
            :steps="howToUseSteps"
            disclaimer="HKCM bietet Marktanalysen und Szenarien auf Basis der Elliott-Wellen-Theorie. Es erfolgt keine Anlageberatung und keine Kaufabwicklung."
            disclaimer-color="#000000"
            active-step-color="#2563eb"
            inactive-step-color="#1e3a5f"
            line-color="#1e3a5f"
            label-color="#1a1a1a"
        />

        <!-- 13) SECTION – Über HKCM -->
        <WhoIsBehindSection
            background-color="bg-[#006cff1a]"
            title="Wer hinter HKCM steht"
            title-highlight="HKCM"
            title-highlight-color="#0d9488"
            title-color="#1a1a1a"
            intro-text="Strukturierte Marktanalyse mit klarer Methodik — transparent, nachvollziehbar und regelmäßig aktualisiert."
            intro-text-color="#000"
            :paragraphs="whoIsBehindParagraphs"
            paragraph-color="#000"
            image="/hkcm/images/team/pk.jpg"
            image-alt="Philip Klinkmüller"
            badge-top-text="Über"
            badge-main-text="70 %"
            badge-bottom-text="Trefferquote"
            :features="whoIsBehindFeatures"
            feature-title-color="text-[#006CFF]"
            feature-subtitle-color="#000"
            checkmark-color="text-[#006CFF]"
        />

        <!-- 14) FINAL CTA -->
        <FinalCTASection
            background-color="linear-gradient(to bottom, #072551, #020E20)"
            title="Finden Sie jetzt das passende Aktienanalyse-Paket für Ihre Strategie"
            title-highlight="Aktienanalyse-Paket"
            title-highlight-gradient-from="#11D2D4"
            title-highlight-gradient-to="#0C7475"
            title-color="text-white"
            description="Alle Pakete basieren auf methodischer Marktanalyse statt Prognose — transparent und strukturiert abgeleitet."
            description-color="text-gray-200"
            image="/hkcm/images/zugang_zum_hype_aktien_paket.png"
            image-alt=""
            image-position="left"
            cta-text="Analyse-Pakete jetzt kaufen"
            cta-link="/produkte"
            button-gradient-from="#11D2D4"
            button-gradient-to="#0C7475"
            price-color="text-blue"
            fallback-cta-text="Hype-Aktien-Paket kaufen ab dem 23.02.2026"
            fallback-cta-background-color="#1E40AF"
        />

        <!-- 15) FOOTER -->
        <LandingFooter
            background-color="#FFFFFF"
            logo="/hkcm/images/logo-on-light-background.svg"
            logo-link="/produkte"
            link-color="text-gray-600"
            cta-text="Analyse-Pakete entdecken"
            cta-link="/produkte"
            button-gradient-from="#1E40AF"
            button-gradient-to="#1E40AF"
            fallback-cta-text="Hype-Aktien-Paket kaufen ab dem 23.02.2026"
            fallback-cta-background-color="#1E40AF"
        />
    </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import i18next from 'i18next';
import LandingNav from '../components/landing/LandingNav.vue';
import HeroSection from '../components/landing/HeroSection.vue';
import VideoSection from '../components/landing/VideoSection.vue';
import ContentSection from '../components/landing/ContentSection.vue';
import ImageContentSection from '../components/landing/ImageContentSection.vue';
import FeatureCardsSection from '../components/landing/FeatureCardsSection.vue';
import SupportListSection from '../components/landing/SupportListSection.vue';
import AccordionSection from '../components/landing/AccordionSection.vue';
import VideoContentSection from '../components/landing/VideoContentSection.vue';
import AnalysePaketeSection from '../components/landing/AnalysePaketeSection.vue';
import HowToUseSection from '../components/landing/HowToUseSection.vue';
import WhoIsItForSection from '../components/landing/WhoIsItForSection.vue';
import WhatYouGetSection from '../components/landing/WhatYouGetSection.vue';
import MethodologySection from '../components/landing/MethodologySection.vue';
import WhoIsBehindSection from '../components/landing/WhoIsBehindSection.vue';
import LandingFooter from '../components/landing/LandingFooter.vue';
import FinalCTASection from '../components/landing/FinalCTASection.vue';
import AboutSection from '../components/landing/AboutSection.vue';

// App Store data
const appStoreData = {
    link: 'https://apps.apple.com/de/app/hkcm/id6499010943',
    badge: i18next.language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png',
    rating: '4.4',
    stars: '/hkcm/images/stars4_5_yellow.png',
    reviews: '1.8k'
};

// Google Play data
const googlePlayData = {
    link: 'https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1',
    badge: i18next.language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png',
    rating: '4.5',
    stars: '/hkcm/images/stars4_5_green.png',
    reviews: '7.3k'
};

// Hero badges
const heroBadges = [
    { src: '/hkcm/images/partners/BlackBull24_Krypto_square.png', alt: 'Black Bull Krypto Insider' },
    { src: '/hkcm/images/partners/BlackBull25_InvestmentVision.png', alt: 'Black Bull Krypto Insider' },
    { src: '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', alt: 'Black Bull Krypto Insider', class: 'w-full object-contain max-h-[180px] lg:w-auto' }
];

// Hero benefits
const heroBenefits = [
    'Chartanalyse mit klaren<br class="hidden lg:block"> Einstiegs- und<br class="hidden lg:block"> Ausstiegsmarken',
    'Regelmäßige Updates<br class="hidden lg:block"> der analysierten<br class="hidden lg:block"> Einzeltitel',
    'Elliott Wellen<br class="hidden lg:block"> Methodik statt<br class="hidden lg:block"> Prognose-Meinung',
    'Strukturierte Szenarien<br class="hidden lg:block"> für verschiedene<br class="hidden lg:block"> Marktphasen'
];

// Section 4 paragraphs
const section4Paragraphs =
    'Viele Anleger starten am Kapitalmarkt mit einem naheliegenden Ansatz.<br class="hidden lg:block">' +
    ' Sie lesen Schlagzeilen und schauen auf kurzfristige Kursbewegungen.<br class="hidden lg:block"> Das Problem ist fehlende Struktur.<br class="hidden lg:block"> Nachrichten sagen selten, was Anleger wirklich brauchen.<br class="hidden lg:block">' +
    ' Nämlich zwei einfache Antworten: <span class="font-bold">Wo investiere ich mein Geld</span> und <span class="font-bold">wann</span>.<br class="hidden lg:block"> Ohne methodische Marktstruktur entstehen typische Fehler: ' +
    '<ul style="list-style-type:disc; margin-left: 30px; margin-bottom: 10px;">' +
    '<li>Einstieg ohne Plan</li>' +
    '<li>Kein Risikomanagement</li>' +
    '<li>Meinungen statt Marken</li>' +
    '<li>Reaktion statt Entscheidung</li>' +
    '</ul>' +
    'Unsere Aktienpakete liefern strukturierte Analysen und klar definierte Kursmarken — auf Basis der Elliott-Wellen-Methodik.';

// Section 4 Tiles
const section4Tiles = [
    { title: '+15', description: 'Jahre Erfahrung am <br class="lg:block hidden"> Markt' },
    { title: '+15.000', description: 'Analysen<br class="lg:block hidden"> erstellt' },
    { title: '+1 mio.', description: 'Follower auf<br class="lg:block hidden"> YouTube' },
    { title: '+290', description: 'Durchschnittlich <br class="lg:block hidden"> Analysen im Monat' }
];

// Analyse Packages
const analysePakete = [
    {
        name: 'KI-Aktien',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/ki.png',
        link: '/produkte/ki-aktien',
        buttonText: 'Auswählen',
        infoText: 'Künstliche Intelligenz Aktienanalysen'
    },
    {
        name: 'Tech33',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/tech-33.png',
        link: '/produkte/tech33-aktien',
        buttonText: 'Auswählen',
        infoText: '33 führende Technologie-Aktien'
    },
    {
        name: 'Euro-Titans',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/euro-titans.png',
        link: '/produkte/euro-titans',
        buttonText: 'Auswählen',
        infoText: 'Europäische Blue-Chip Aktien'
    },
    {
        name: 'US-Titans',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/ustitans.png',
        link: '/produkte/us-titans',
        buttonText: 'Auswählen',
        infoText: 'Amerikanische Blue-Chip Aktien'
    },
    {
        name: 'China-Titans',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/china-titans.png',
        link: '/produkte/china-titans',
        buttonText: 'Auswählen',
        infoText: 'Chinesische Top-Aktien'
    },
    {
        name: 'Hype-Aktien',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/hype.png',
        link: '/produkte/hype-aktien',
        buttonText: 'Auswählen',
        infoText: 'Trendstarke Momentum-Aktien'
    },
    {
        name: 'Minen',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/minen.png',
        link: '/produkte/minen',
        buttonText: 'Auswählen',
        infoText: 'Bergbau- und Rohstoff-Aktien'
    }
];

// How to Use Steps
const howToUseSteps = [
    {
        label: 'Analysepaket\nauswählen',
        active: true,
        iconImage: '/hkcm/icons/landing/package.svg',
        icon: { paths: [] }
    },
    {
        label: 'Zugriff\nerhalten',
        active: false,
        iconImage: '/hkcm/icons/landing/key.svg',
        icon: { paths: [] }
    },
    {
        label: 'Kursmarken &\nSzenarien einsehen',
        active: false,
        iconImage: '/hkcm/icons/landing/chart-line-white.svg',
        icon: { paths: [] }
    },
    {
        label: 'Eigene Entscheidungen\n ableiten',
        active: false,
        iconImage: '/hkcm/icons/landing/lightbulb-white.svg',
        icon: { paths: [] }
    }
];

// Who Is It For Cards
const whoIsItForCards = [
    {
        title: '… Sie Ihre Investmententscheidungen selbst treffen',
        description:
            'Sie möchten nicht blind Empfehlungen folgen, sondern nachvollziehen, warum bestimmte Marktbewegungen entstehen können.<br> Unsere Analysen zeigen Struktur, Szenarien und Entscheidungsmarken — die Umsetzung liegt bei Ihnen.',
        icon: '/hkcm/icons/landing/brain.svg'
    },
    {
        title: '… Sie mit Kursmarken und Szenarien arbeiten möchten',
        description:
            'Unsere Methodik liefert keine pauschalen „Kaufen / Verkaufen"-Aussagen.<br> Stattdessen erhalten Sie konkrete Marktmarken und alternative Szenarien.<br> Das ist ideal für Anleger, die strukturiert planen und Entscheidungen an klaren Bedingungen ausrichten möchten.',
        icon: '/hkcm/icons/landing/chart-line-up.svg'
    },
    {
        title: '… Sie regelmäßig Kapital in Aktien investieren',
        description:
            'Die Analysepakete entfalten ihren größten Nutzen für Anleger, die fortlaufend investieren oder bestehende Positionen aktiv managen.<br> Wenn Sie monatlich oder regelmäßig Kapital am Markt einsetzen, helfen strukturierte Marktanalysen besonders bei Timing- und Risikofragen.',
        icon: '/hkcm/icons/landing/coins.svg'
    },
    {
        title: '… Sie Marktbewegungen besser verstehen wollen',
        description:
            'Viele Nutzer schätzen unsere Analysen nicht nur wegen der Marken — sondern wegen des Marktverständnisses.<br> Sie lernen zu erkennen: in welcher Marktphase sich eine Aktie befindet, ob eine Bewegung strukturell stabil wirkt, wo Korrekturen typisch sind, wann Strukturen brechen.<br> Das stärkt Ihre eigene Entscheidungskompetenz.',
        icon: '/hkcm/icons/landing/lightbulb.svg'
    }
];

// Methodology Accordion Items
const methodologyAccordionItems = ref([
    {
        question: 'Was ist die Elliott-Wellen-Theorie?',
        answer: 'Die Elliott-Wellen-Theorie ist eine technische Analyse-Methodik, die Marktbewegungen in wiederkehrenden Mustern beschreibt.',
        isOpen: true
    },
    {
        question: 'Warum nutzen wir diese Methodik für Aktienanalysen?',
        answer: 'Weil sie strukturierte Szenarien ermöglicht und nicht auf Meinung, sondern auf nachvollziehbaren Marktmustern basiert.',
        isOpen: false
    },
    {
        question: 'Szenario-Logik statt Einweg-Prognose',
        answer: 'Wir arbeiten mit alternativen Szenarien: Was passiert, wenn Marke X gebrochen wird? Was, wenn sie hält? Das ermöglicht Ihnen flexible Entscheidungen.',
        isOpen: false
    },
    {
        question: 'Transparente Kursmarken statt vager Aussagen',
        answer: `Unsere Analysen enthalten konkrete Kursmarken, zum Beispiel:
• mögliche Zielzonen
• Korrekturbereiche
• Strukturbrüche
• Invalidation Levels

Das sind keine Kaufaufforderungen, sondern Orientierungsmarken.
Sie helfen Ihnen zu verstehen:
• wo sich eine Bewegung bestätigt
• wo sie fraglich wird
• wo sich das Bild strukturell ändert`,
        isOpen: false
    }
]);

// Accordion items
const accordionItems = ref([
    {
        title: 'Sie trendstarke Aktien früh erkennen und einordnen wollen',
        content:
            'Sie interessieren sich für Titel, die gerade stark im Marktfokus stehen, nicht erst, wenn der Trend vorbei ist. Sie wollen verstehen, wo Momentum strukturell bestätigt wird und wo Vorsicht geboten ist.',
        isOpen: true,
        icon: 'fi fi-rr-arrow-trend-up'
    },
    {
        title: 'Sie Volatilität nicht fürchten - sondern einordnen möchten',
        content:
            'Hype-Aktien bewegen sich oft schneller und stärker als der Gesamtmarkt. Unsere Chartanalysen helfen Ihnen, diese Bewegungen strukturiert zu bewerten, statt nur emotional zu reagieren.',
        isOpen: false,
        icon: 'fi fi-rr-shield-check'
    },
    {
        title: 'Sie mit Szenarien statt Schlagzeilen arbeiten wollen',
        content: 'Sie möchten Entscheidungen nicht auf Basis von Social-Media-Meinungen oder News-Überschriften treffen, sondern mit klaren Chartanalysen.',
        isOpen: false,
        icon: 'fi fi-rr-display-chart-up'
    },
    {
        title: 'Sie fokussierte Chancenpakete bevorzugen',
        content: 'Statt 50+ durchschnittlicher Titel bevorzugen Sie eine kuratierte Auswahl stark beobachteter Aktien, aktiv betreut und regelmäßig überprüft.',
        isOpen: false,
        icon: 'fi fi-rr-box-alt'
    }
]);

const featureCards = [
    {
        title: 'Klare<br>Handelsmöglichkeiten',
        icon: '/hkcm/icons/landing/crosshair.svg',
        content:
            'Einstiegs- und Ausstiegszonen auf Basis der Elliott-Wellen-Analyse zum einfachen Nachhandeln: Per Mail, direkt in die App (inklusive Push-Benachrichtigung) oder jederzeit im HKCM-Dashboard.'
    },
    {
        title: 'Zugang zum<br>Musterportfolio',
        icon: '/hkcm/icons/landing/briefcase.svg',
        content: 'Unser Musterportfolio macht unsere Performance und Handelsentscheidungen jederzeit nachvollziehbar.'
    },
    {
        title: 'Tägliche<br>Analyse',
        icon: '/hkcm/icons/landing/chart-line.svg',
        content: 'In detaillierten schriftlichen Aktienanalysen erhalten Sie werktäglich schriftliche Updates der bedeutendsten Unternehmen für den Sektor Ihrer Wahl.'
    },
    {
        title: 'Schnelle Reaktionen auf<br>Marktbewegungen',
        icon: '/hkcm/icons/landing/lightning.svg',
        content: 'Bei starken Kursbewegungen oder wichtigen Ereignissen erhalten Sie kurze Updates, direkt als Kurznachricht in Ihrem Dashboard oder in der HKCM-App.'
    },
    {
        title: 'Für alle Trader und<br>Investoren',
        icon: '/hkcm/icons/landing/users-three.svg',
        content:
            'Ob langfristig oder kurzfristig, ob Sie in Aktien, CFDs oder Derivate investieren – Sie profitieren stets von klar definierten Einstiegs-, Ausstiegs-, Take-Profit- und Stoppmarken, die Ihnen Orientierung und Struktur im Handel bieten.'
    },
    {
        title: 'Übersichtliche<br>Chartbilder',
        icon: '/hkcm/icons/landing/chart-bar.svg',
        content:
            'Mit klar markierten Unterstützungen, Widerständen und Zielzonen geben Ihnen die Chartbilder eine wertvolle Orientierung, sowohl auf der Long- als auch auf der Short-Seite.'
    }
];

// Who Is Behind Section - Paragraphs
const whoIsBehindParagraphs = [
    'HKCM steht für strukturierte Marktanalyse statt Meinungsprognose. Unser Fokus liegt darauf, Marktbewegungen methodisch einzuordnen und daraus klare Szenarien sowie Kursmarken abzuleiten.',
    'Unsere Analysen basieren auf der Elliott-Wellen-Theorie – nicht, weil sie „kompliziert klingt", sondern weil sie Marktphasen und Korrekturen systematisch beschreibbar macht. Das Ziel ist nicht, den Markt perfekt vorherzusagen, sondern Ihnen ein nachvollziehbares Modell zu geben, mit dem Sie Entscheidungen strukturierter treffen können.',
    'Wir arbeiten mit einem szenariobasierten Ansatz. Das bedeutet: Sie erhalten nicht nur eine Richtung, sondern mehrere mögliche Entwicklungen — inklusive klarer Marken, ab wann ein Szenario bestätigt oder verworfen ist. So entsteht Orientierung, gerade in volatilen Marktphasen.'
];

// Who Is Behind Section - Features
const whoIsBehindFeatures = [
    {
        title: "Methodik statt<br class='hidden lg:block'> Meinung",
        subtitle: "feste<br class='hidden lg:block'> Analyse-Logik"
    },
    {
        title: "Szenarien statt<br class='hidden lg:block'> Prognosen",
        subtitle: "klar<br class='hidden lg:block'> definierte Bedingungen"
    },
    {
        title: "Kursmarken statt<br class='hidden lg:block'> Bauchgefühl",
        subtitle: "transparente<br class='hidden lg:block'> Entscheidungszonen"
    },
    {
        title: "Regelmäßige<br class='hidden lg:block'> Updates",
        subtitle: "Anpassungen bei<br class='hidden lg:block'> Marktveränderungen"
    }
];
</script>
<style></style>
